import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { GenericAutocompleteResultsModule } from '../../generic-autocomplete-results';
import { GenericSearchModule } from '../../generic-search';
import { TransitProgramSearchDialogComponent } from './transit-program-search-dialog.component';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, GenericSearchModule, GenericAutocompleteResultsModule, MatDividerModule],
  declarations: [TransitProgramSearchDialogComponent],
  exports: [TransitProgramSearchDialogComponent]
})
export class TransitProgramSearchModule {}
